export function truncateAtWord(text: string, maximumNumbers: number, isHtml?: boolean): string {
    if (!text) return text;
    if (isHtml) {
        const tmp = document.createElement('DIV');
        tmp.innerHTML = text;
        text = tmp.textContent || tmp.innerText || '';
    }
    if (text.length > maximumNumbers) {
        const indexNextSpace = text.lastIndexOf(' ', maximumNumbers);
        return String.format('{0}{1}', text.substring(0, indexNextSpace > 0 ? indexNextSpace : maximumNumbers), '...');
    }

    return text;
}
